import React, {useState} from "react";

// DMU
import Y1 from "../helpers/wagons/Y1";
import Y6 from "../helpers/wagons/Y6";
import Y7 from "../helpers/wagons/Y7";
import Y8 from "../helpers/wagons/Y8";

// Passenger coaches
import A2 from "../helpers/wagons/A2";
import AB3 from "../helpers/wagons/AB3";
import ABS5 from "../helpers/wagons/ABS5";
import B1 from "../helpers/wagons/B1";
import B1S from "../helpers/wagons/B1S";
import B5 from "../helpers/wagons/B5";
import B7 from "../helpers/wagons/B7";
import B22 from "../helpers/wagons/B22";
import B22D from "../helpers/wagons/B22D";
import Co4a from "../helpers/wagons/Co4a";
import Co2 from "../helpers/wagons/Co2";
import Co12 from "../helpers/wagons/Co12";
import Co65 from "../helpers/wagons/Co65";
import C49 from "../helpers/wagons/C49";
import CD268 from "../helpers/wagons/CD268";

export default function Wagon(props) {
    const { id, reservedSeats, preliminaryReservedSeats, announcedNumber, series, number } = props;

    const WagonType = {
        Y1: <Y1 id={id} reservedSeats={reservedSeats} preliminaryReservedSeats={preliminaryReservedSeats} number={number} announcedNumber={announcedNumber} />,
        Co2: <Co2 id={id} reservedSeats={reservedSeats} preliminaryReservedSeats={preliminaryReservedSeats} number={number} announcedNumber={announcedNumber} />,
        Co4a: <Co4a id={id} reservedSeats={reservedSeats} preliminaryReservedSeats={preliminaryReservedSeats} number={number} announcedNumber={announcedNumber} />,
        Co12: <Co12 id={id} reservedSeats={reservedSeats} preliminaryReservedSeats={preliminaryReservedSeats} number={number} announcedNumber={announcedNumber} />,
        Co65: <Co65 id={id} reservedSeats={reservedSeats} preliminaryReservedSeats={preliminaryReservedSeats} number={number} announcedNumber={announcedNumber} />,
        C49: <C49 id={id} reservedSeats={reservedSeats} preliminaryReservedSeats={preliminaryReservedSeats} number={number} announcedNumber={announcedNumber} />,
        CD268: <CD268 id={id} reservedSeats={reservedSeats} preliminaryReservedSeats={preliminaryReservedSeats} number={number} announcedNumber={announcedNumber} />,
        Y6: <Y6 id={id} reservedSeats={reservedSeats} preliminaryReservedSeats={preliminaryReservedSeats} number={number} announcedNumber={announcedNumber} />,
        Y7: <Y7 id={id} reservedSeats={reservedSeats} preliminaryReservedSeats={preliminaryReservedSeats} number={number} announcedNumber={announcedNumber} />,
        Y8: <Y8 id={id} reservedSeats={reservedSeats} preliminaryReservedSeats={preliminaryReservedSeats} number={number} announcedNumber={announcedNumber} />,
        A2: <A2 id={id} reservedSeats={reservedSeats} preliminaryReservedSeats={preliminaryReservedSeats} number={number} announcedNumber={announcedNumber} />,
        ABS5: <ABS5 id={id} reservedSeats={reservedSeats} preliminaryReservedSeats={preliminaryReservedSeats} number={number} announcedNumber={announcedNumber} />,
        AB3: <AB3 id={id} reservedSeats={reservedSeats} preliminaryReservedSeats={preliminaryReservedSeats} number={number} announcedNumber={announcedNumber} />,
        B1: <B1 id={id} reservedSeats={reservedSeats} preliminaryReservedSeats={preliminaryReservedSeats} number={number} announcedNumber={announcedNumber} />,
        B1S: <B1S id={id} reservedSeats={reservedSeats} preliminaryReservedSeats={preliminaryReservedSeats} number={number} announcedNumber={announcedNumber} />,
        B5: <B5 id={id} reservedSeats={reservedSeats} preliminaryReservedSeats={preliminaryReservedSeats} number={number} announcedNumber={announcedNumber} />,
        B7: <B7 id={id} reservedSeats={reservedSeats} preliminaryReservedSeats={preliminaryReservedSeats} number={number} announcedNumber={announcedNumber} />,
        B22: <B22 id={id} reservedSeats={reservedSeats} preliminaryReservedSeats={preliminaryReservedSeats} number={number} announcedNumber={announcedNumber} />,
        B22D: <B22D id={id} reservedSeats={reservedSeats} preliminaryReservedSeats={preliminaryReservedSeats} number={number} announcedNumber={announcedNumber} />,
    };

    return (
        <div className="wagon">
            <h4 className="text-center text-base font-light text-indigo-600 tracking-wide uppercase mt-4">Vagn { announcedNumber ?? series + ' ' + number}</h4>
            {WagonType[series]}
        </div>
    )
}
